export type NewsCategory = "新闻" | "活动" | "公告";

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  date: string;
  category: NewsCategory;
  tags: string[];
  cover: string;
  content: string[];
}

export const news: NewsItem[] = [
  {
    id: "chang-ye-jiang-ming-premiere",
    title: "《长夜将明》全国路演启动，导演周慕白携主创亮相首站",
    summary: "由朝桐光出品的悬疑电影《长夜将明》正式开启全国路演，导演周慕白及主演沈亦舟、苏晚宁出席首站活动，与影迷面对面交流创作幕后。",
    date: "2026.09.28",
    category: "活动",
    tags: ["长夜将明", "路演", "周慕白"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20stage%20premiere%20event%20with%20warm%20amber%20spotlights%20and%20a%20large%20dark%20screen%2C%20deep%20navy%20and%20gold%20tones%2C%20elegant%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-cover-01&orientation=landscape",
    content: [
      "9 月 28 日，朝桐光出品的悬疑电影《长夜将明》正式拉开全国路演序幕。首站活动现场座无虚席，导演周慕白携主演沈亦舟、苏晚宁一同亮相，与到场影迷分享了影片从剧本打磨到实景拍摄的完整历程。",
      "谈及创作初衷，周慕白表示，《长夜将明》真正想讲的并不是“谁是凶手”，而是人在极端处境下如何做出选择。“我们希望观众走出影院时，带走的不只是谜底，还有一个关于自己的问题。”",
      "沈亦舟在片中一人分饰多个阶段的角色，他坦言这是从影以来最具挑战的一次表演：“为了让人物在不同阶段的气质自然过渡，我提前三个月就开始做体能和状态管理，几乎把剧本翻烂了。”",
      "活动最后，主创团队与全场观众合影留念，并公布了后续十余座城市的路演安排。朝桐光方面表示，未来将继续以高质量内容回馈影迷的期待。",
    ],
  },
  {
    id: "shan-hai-xun-zong-ratings",
    title: "《山海寻踪》热度口碑双丰收，连续三周登顶剧集榜",
    summary: "朝桐光奇幻大剧《山海寻踪》开播以来表现亮眼，连续三周位居剧集热度榜首位，豆瓣开分 8.8，被观众称为“年度东方奇幻”。",
    date: "2026.09.20",
    category: "新闻",
    tags: ["山海寻踪", "剧集", "口碑"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20fantasy%20landscape%20of%20floating%20mountain%20peaks%20above%20a%20sea%20of%20clouds%20at%20dawn%20with%20warm%20amber%20light%2C%20deep%20indigo%20sky%2C%20epic%20atmospheric%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-cover-02&orientation=landscape",
    content: [
      "由朝桐光出品的东方奇幻剧集《山海寻踪》自开播以来持续引发讨论。据平台数据显示，该剧已连续三周位居剧集热度榜首位，正片有效播放市占率稳步攀升。",
      "在口碑层面，《山海寻踪》同样表现扎实，豆瓣开分 8.8，并长期维持在 8.7 以上。观众普遍认为，剧集在宏大世界观与细腻人物塑造之间取得了难得的平衡。",
      "主演江暮辞、林知夏、陆屿的表现获得一致好评。尤其是江暮辞饰演的守山人，被网友称为“整部剧的情绪锚点”。",
      "朝桐光制作团队透露，剧中大量山海场景均采用实景与数字技术结合的方式完成，仅云雾体系就迭代了数十版，只为让东方美学更具质感。",
    ],
  },
  {
    id: "studio-annual-slate-2026",
    title: "朝桐光发布 2026 年度片单，八大项目集中亮相",
    summary: "朝桐光在年度发布会上公布 2026 年度片单，涵盖悬疑、科幻、历史、家庭等多元题材，共八大重点影视项目。",
    date: "2026.09.12",
    category: "新闻",
    tags: ["片单", "发布会", "2026"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20elegant%20dark%20press%20conference%20stage%20with%20warm%20amber%20accent%20lighting%20and%20a%20minimal%20logo%20backdrop%2C%20deep%20navy%20tones%2C%20premium%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-cover-03&orientation=landscape",
    content: [
      "9 月 12 日，朝桐光年度发布会在京举行，正式公布 2026 年度片单。本次片单共包含八大重点影视项目，题材覆盖悬疑、科幻、历史、家庭与青春等多个方向。",
      "发布会上，朝桐光公布了“内容为王、长期主义”的核心策略，强调将继续加大对原创剧本与青年创作者的投入，让更多优质故事被看见。",
      "片单中包括备受期待的科幻电影《海底的星空》续作计划、历史题材电影《风起敦煌》衍生剧集，以及多部聚焦现实生活的家庭剧集。",
      "多位合作演员及导演出席发布会并分享项目进展。朝桐光表示，未来一年将保持稳定的内容产出节奏，与观众建立更长期、更真诚的连接。",
    ],
  },
  {
    id: "hai-di-de-xing-kong-behind",
    title: "《海底的星空》幕后特辑公开，揭秘深海拍摄的日与夜",
    summary: "朝桐光发布《海底的星空》幕后制作特辑，首次公开剧组在深海实拍与水下摄影方面的技术突破与幕后故事。",
    date: "2026.08.30",
    category: "新闻",
    tags: ["海底的星空", "幕后", "科幻"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20underwater%20scene%20of%20a%20deep%20sea%20trench%20with%20glowing%20blue%20marine%20snow%20particles%20and%20a%20small%20submersible%20with%20warm%20lights%2C%20vast%20atmospheric%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-cover-04&orientation=landscape",
    content: [
      "朝桐光旗下科幻电影《海底的星空》近日发布幕后制作特辑，向观众展示了影片在深海实拍与水下摄影方面的技术探索。",
      "为了真实呈现深海环境，主创团队与专业水下摄影团队合作，搭建了多组大型水下置景，并结合实拍与数字特效，让“海底星空”的意象更具沉浸感。",
      "导演沈亦舟在特辑中表示：“我们希望观众能感受到那种被深海包裹的孤独，也能看到那一点点微弱但坚定的光。”",
      "特辑上线后迅速登上热搜，不少观众留言称“光是幕后就已经值回票价”。影片的相关周边与主题展也将在年内陆续推出。",
    ],
  },
  {
    id: "fan-meeting-2026-autumn",
    title: "朝桐光影迷见面会秋季场开启报名，限量名额先到先得",
    summary: "朝桐光 2026 秋季影迷见面会正式开启报名，参与者将有机会与多位签约演员近距离互动并抢先观看新作片段。",
    date: "2026.08.18",
    category: "活动",
    tags: ["见面会", "影迷", "报名"],
    cover: "https://readdy.ai/api/search-image?query=warm%20cinematic%20photo%20of%20a%20cozy%20fan%20meeting%20event%20space%20with%20string%20lights%20and%20warm%20amber%20glow%20against%20deep%20blue%20evening%20tones%2C%20inviting%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-05&orientation=landscape",
    content: [
      "朝桐光 2026 秋季影迷见面会将于下月举行，即日起正式开启报名。本次见面会以“同行”为主题，希望为长期支持朝桐光的影迷提供一个更真诚的交流空间。",
      "活动当天，多位签约演员将到场与影迷互动，并首次公开未来新作的独家片段。现场还设置了幕后道具展区与主创问答环节。",
      "为保障活动体验，本次见面会采取限量名额制，报名将按先后顺序确认，额满即止。参与者需通过官方渠道完成实名登记。",
      "朝桐光表示，影迷是品牌成长过程中最重要的同行者，未来将持续推出类似活动，让创作与观看之间的距离更近一点。",
    ],
  },
  {
    id: "an-yong-broadcast-notice",
    title: "《暗涌》更新调整公告：本周起改为每周三、周六更新",
    summary: "朝桐光就热播剧《暗涌》的更新节奏发布公告，自本周起调整为每周三、周六各更新两集，敬请留意。",
    date: "2026.08.05",
    category: "公告",
    tags: ["暗涌", "播出", "公告"],
    cover: "https://readdy.ai/api/search-image?query=minimal%20cinematic%20photo%20of%20a%20dark%20grand%20hall%20with%20a%20single%20shaft%20of%20cold%20light%2C%20deep%20navy%20gray%20atmosphere%20with%20a%20hint%20of%20amber%2C%20tense%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-06&orientation=landscape",
    content: [
      "感谢大家一直以来对朝桐光谍战剧《暗涌》的关注与支持。应广大观众反馈，经与播出平台协商，剧集更新节奏自本周起进行调整。",
      "调整后，《暗涌》将于每周三、周六各更新两集，会员可提前观看最新内容。已播出的剧集不受影响，可正常回看。",
      "对于此次更新调整给部分观众带来的不便，我们深表歉意。后续剧情将进入关键阶段，请留意播出时间，避免错过精彩内容。",
      "如有其他疑问，欢迎通过官方网站“联系我们”页面进行反馈，我们会尽快回复。感谢理解与支持。",
    ],
  },
  {
    id: "wind-of-dunhuang-award",
    title: "《风起敦煌》斩获年度最佳美术设计大奖",
    summary: "朝桐光历史电影《风起敦煌》在年度影视盛典中荣获最佳美术设计大奖，评委会称赞其“以色彩复现了一个时代的气韵”。",
    date: "2026.07.22",
    category: "新闻",
    tags: ["风起敦煌", "获奖", "美术"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sweeping%20desert%20dune%20landscape%20at%20sunset%20with%20long%20shadows%20and%20a%20distant%20caravan%2C%20warm%20amber%20light%20against%20deep%20blue%20sky%2C%20epic%20editorial%20photo%2C%20high%20detail&width=800&height=500&seq=news-cover-07&orientation=landscape",
    content: [
      "在近日举行的年度影视盛典上，朝桐光出品的历史电影《风起敦煌》荣获最佳美术设计大奖，成为当晚最受瞩目的作品之一。",
      "评委会在颁奖词中评价：“《风起敦煌》以极致的色彩与考究的细节，复现了一个时代的气韵，让观众在光影中触摸到历史的温度。”",
      "美术指导团队表示，为了让壁画色彩更接近真实，团队多次前往实地采风，并参考了大量文献与图像资料，反复推敲每一处用色。",
      "朝桐光表示，这一奖项属于整个创作团队，也将鼓励公司在未来继续保持对细节的敬畏，为观众呈现更有质感的作品。",
    ],
  },
  {
    id: "new-talent-program",
    title: "朝桐光启动“新光计划”，面向青年创作者开放扶持名额",
    summary: "朝桐光宣布启动青年创作者扶持计划“新光计划”，将提供资金、制作与发行资源，帮助年轻导演与编剧完成首个作品。",
    date: "2026.07.08",
    category: "公告",
    tags: ["新光计划", "青年", "扶持"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20photo%20of%20a%20young%20creator%20writing%20at%20a%20desk%20by%20a%20large%20window%20with%20warm%20afternoon%20light%2C%20deep%20blue%20shadows%20and%20amber%20highlights%2C%20hopeful%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-08&orientation=landscape",
    content: [
      "朝桐光正式启动青年创作者扶持计划“新光计划”，面向全国范围内有潜力的青年导演、编剧开放申请名额。",
      "入选者将获得项目资金、专业制作团队协作以及发行渠道等资源支持，帮助其完成首个具有个人风格的影视作品。",
      "朝桐光表示，行业的长远活力来自不断涌现的新人。“我们愿意做那个点灯的人，让更多年轻的表达被看见。”",
      "“新光计划”首期申报通道将于下月开放，具体细则与申报方式将通过官方网站陆续公布，敬请关注。",
    ],
  },
  {
    id: "cheng-nan-jiu-xiang-anniversary",
    title: "《城南旧巷》开播五周年，主创重聚回顾温暖瞬间",
    summary: "朝桐光年代剧《城南旧巷》迎来开播五周年，主创团队重聚，回顾当年拍摄的点滴与观众共同珍藏的记忆。",
    date: "2026.06.20",
    category: "活动",
    tags: ["城南旧巷", "周年", "重聚"],
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20cinematic%20photo%20of%20a%20narrow%20old%20chinese%20alley%20at%20golden%20hour%20with%20warm%20sunlight%20and%20hanging%20laundry%2C%20muted%20blue%20shadows%20and%20amber%20highlights%2C%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-09&orientation=landscape",
    content: [
      "近日，朝桐光年代剧《城南旧巷》迎来开播五周年。主创团队特别重聚，与观众一同回顾这部温暖作品走过的五年时光。",
      "导演柳砚青回忆，当年为了还原真实的老巷生活，剧组花了大量时间走访、采风，甚至请来了当地居民参与置景。",
      "主演韩景轩、白露也分享了拍摄期间的趣事。白露笑称：“那段时间我们真的像一家人，收工了还舍不得散。”",
      "五年过去，《城南旧巷》依然被许多观众反复重温。朝桐光表示，这份长久的陪伴，正是团队继续创作的动力。",
    ],
  },
  {
    id: "seventh-letter-teaser",
    title: "《第七封信》首支预告释出，温柔氛围感收割好评",
    summary: "朝桐光爱情电影《第七封信》发布首支预告，细腻的镜头语言与温柔的氛围感获得网友一致好评，期待值持续攀升。",
    date: "2026.06.02",
    category: "新闻",
    tags: ["第七封信", "预告", "爱情"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20soft%20focus%20photo%20of%20letters%20and%20a%20dried%20flower%20on%20a%20wooden%20desk%20by%20a%20sunlit%20window%2C%20warm%20cream%20tones%20with%20muted%20blue%20shadows%2C%20tender%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=news-cover-10&orientation=landscape",
    content: [
      "朝桐光爱情电影《第七封信》日前发布首支正式预告。短短两分钟的片段，以温柔的光影和克制的叙事，收获了网友的一致好评。",
      "预告片中，一封封未署名的信与秋日的光线交织在一起，营造出极具氛围感的画面。不少观众留言表示“光看完预告就已经被治愈了”。",
      "导演沈亦舟表示，影片希望传递的是一种“刚刚好”的情感——不浓烈，但足够长久。“有些话，写下来比说出来更容易。”",
      "《第七封信》目前正在紧张的制作收尾阶段，预计将于年内与观众见面，更多信息敬请关注朝桐光官方动态。",
    ],
  },
];

export const newsCategories = ["全部", "新闻", "活动", "公告"];